import { Switch, Route, Redirect } from "react-router-dom";
import Login from "./pages/auth/Login";
import Pages404 from "./components/PageNotFound";
import { authProtectedRoutes, publicRoutes, tFARoutes } from "./routes";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import authState from "./atom/auth";
import i18next from "i18next";
import tFA from "./atom/tFA";

const App = () => {
  const [auth, setAuth] = useRecoilState(authState);
  const [tFAMandatory, setTFAMandatory] = useRecoilState(tFA);

  useEffect(() => {
    if (auth) {
      document.documentElement.setAttribute("lang", i18next.language);
    } else {
      document.documentElement.setAttribute("lang", i18next.language);
    }
  }, [auth]);

  useEffect(() => {
    require(`./assets/scss/theme${
      i18next.language === "ar" ? "-rtl" : ""
    }.scss`);
  }, [i18next.language]);

  return (
    <Switch>
      <Route path="/login">
        {localStorage.getItem("token") ? (
          <Redirect to="/" />
        ) : (
          <NonAuthLayout>
            <Login />
          </NonAuthLayout>
        )}
      </Route>

      {publicRoutes.map((route, idx) => (
        <Route
          path={route.path}
          exact
          key={idx}
          render={(props) =>
            localStorage.getItem("token") ? (
              <Redirect to="/" />
            ) : (
              <NonAuthLayout>
                <route.component {...props} />
              </NonAuthLayout>
            )
          }
        />
      ))}

      {authProtectedRoutes.map((route, idx) => (
        <Route
          path={route.path}
          exact
          key={idx}
          render={(props) => {
            const token = localStorage.getItem("token");
            const twoFactorEnabled = JSON.parse(
              localStorage.getItem("twoFactorEnabled")
            );

            if (token) {
              if (tFAMandatory || true) {
                if (twoFactorEnabled) {
                  return (
                    <VerticalLayout>
                      <route.component {...props} />
                    </VerticalLayout>
                  );
                } else {
                  return <Redirect to="/two-factor-authintication" />;
                }
              } else {
                return <Redirect to="/" />;
              }
            } else {
              return <Redirect to="/login" />;
            }
          }}
        />
      ))}

      {tFARoutes.map((route, idx) => (
        <Route
          path={route.path}
          exact
          key={idx}
          render={(props) =>
            localStorage.getItem("token") ? (
              <VerticalLayout>
                <route.component {...props} />
              </VerticalLayout>
            ) : (
              <Redirect to="/login" />
            )
          }
        />
      ))}

      <Route>
        <NonAuthLayout>
          <Pages404 />
        </NonAuthLayout>
      </Route>
    </Switch>
  );
};

export default App;
